var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "exam-notice" }, [
    this.currentExamInfo.id
      ? _c("div", { domProps: { innerHTML: _vm._s(_vm.regNotice) } })
      : _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "justify-content": "center",
              "align-items": "center",
              "flex-direction": "column",
              "min-height": "calc(100vh - 120px)",
            },
          },
          [
            _vm._m(0),
            _c("div", { staticStyle: { "margin-top": "30px" } }, [
              _vm._v("暂无考试可报名！"),
            ]),
          ]
        ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "print-btn" }, [
      _c("i", {
        staticClass: "el-icon-circle-close",
        staticStyle: { "font-size": "66px" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }